import React from 'react';
import { useReveal } from '../hooks/useReveal';

/**
 * Envoltorio para revelar elementos al entrar en viewport sin
 * violar las reglas de hooks dentro de .map().
 */
const RevealItem = ({ as: Tag = 'div', delay = 0, className = '', children, ...rest }) => {
  const { ref } = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal ${className}`}
      style={{ transitionDelay: `${delay}ms`, ...(rest.style || {}) }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default RevealItem;
